export default [
    {
        path: '/',
        name: 'gateway',
        component: () => import('../views'),
        // redirect: '/mircoApp'
    },
    // {
    //     path: '/mircoApp',
    //     name: 'mircoApp',
    //     component: () => import('../views'),
    // },
]